<template>
    <button
        class="ani-about-scroll-btn flex items-center justify-center rounded-full bg-base-doveGrey px-3 py-5"
    >
        <span class="relative rotate-90 overflow-hidden">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                v-for="i in 2"
                :key="i"
                :class="[{ 'absolute -translate-x-full': i === 1 }]"
            >
                <path
                    d="M19.5 12H3.5"
                    stroke="black"
                    stroke-width="2.5"
                    stroke-linecap="round"
                />
                <path
                    d="M15 6L20.1161 11.1161C20.6043 11.6043 20.6043 12.3957 20.1161 12.8839L15 18"
                    stroke="black"
                    stroke-width="2.5"
                    stroke-linecap="round"
                />
            </svg>
        </span>
    </button>
</template>

<script setup>
import { atomsArrowButtonAnimate } from "@/lib/gsap-about";
import { killAnimation } from "@/lib/gsap-core";

let tl = null;
onMounted(() => {
    tl = atomsArrowButtonAnimate();
});
onBeforeUnmount(() => {
    killAnimation(tl);
});
</script>
